import React, { useState } from 'react'

function Anexos({ anexos }) {
    const [open, setOpen] = useState(false)

    return (
        <div className="cond-anexos">
            <div className="cond-anexos-title" onClick={() => setOpen(!open)}>
                <div className="title-content">
                    <i className="ti-clip"></i>
                    <span>Anexos</span>
                    <i className={open ? 'ti-angle-up' : 'ti-angle-down'}></i>
                </div>
            </div>
            {open && (
                <div className="cond-anexos-content">
                    {anexos.map((anexo, index) => (
                        <a key={index} href={anexo.url} target="_blank" rel="noopener noreferrer" className="anexo-item">
                            <i className="ti-cloud-down"></i>
                            <span className="file-name">{anexo.nome_original}</span>
                        </a>
                    ))}
                </div>
            )}
        </div>
    )
}

export default Anexos